import M1 from '../assets/images/catalogTableImages/1.png';
import M2 from '../assets/images/catalogTableImages/2.png';
import M3 from '../assets/images/catalogTableImages/3.png';
import M4 from '../assets/images/catalogTableImages/4.png';
import M5 from '../assets/images/catalogTableImages/5.png';
import M6 from '../assets/images/catalogTableImages/6.png';
import M7 from '../assets/images/catalogTableImages/7.png';
import M8 from '../assets/images/catalogTableImages/8.png';
import M9 from '../assets/images/catalogTableImages/9.png';
import M10 from '../assets/images/catalogTableImages/10.png';
import M11 from '../assets/images/catalogTableImages/11.png';
import M12 from '../assets/images/catalogTableImages/12.png';
import M13 from '../assets/images/catalogTableImages/13.png';
import M14 from '../assets/images/catalogTableImages/14.png';
import M15 from '../assets/images/catalogTableImages/15.png';
import M16 from '../assets/images/catalogTableImages/16.png';


export default function getCatalogTable() {
    return[
        {
            label: `алергологічні`,
            img: M10,
            id: '10',
        },
        {
            label: `біохімічні`,
            img: M3,
            id: '3',
        },
        {
            label: `загальноклінічні`,
            img: M2,
            id: '2',
        },
        {
            label: `генетичні`,
            img: M11,
            id: '11',
        },
        {
            label: `онкомаркери`,
            img: M7,
            id: '7',
        },
        {
            label: `забір біоматеріалу`,
            img: M15,
            id: '15',
        },
        {
            label: `показники імунної системи`,
            img: M9,
            id: '9',
        },
        {
            label: `мікробіологічні`,
            img: M12,
            id: '12',
        },
        {
            label: `паразитарні`,
            img: M14,
            id: '14',
        },
        {
            label: `показники системи гемостазу`,
            img: M4,
            id: '4',
        },
        {
            label: `гормональні`,
            img: M6,
            id: '6',
        },
        {
            label: `ургентні`,
            img: M5,
            id: '5',
        },
        {
            label: `цитологічні та патогістологічні`,
            img: M13,
            id: '13',
        },
        {
            label: `інфекції`,
            img: M8,
            id: '8',
        },
        {
            label: `перелік всіх аналізів`,
            img: M1,
            id: '1',

        },
        {
            label: ` як підготуватися`,
            img: M16,
            id: '16',
        },

    ];
}